<ng-container>
    <mat-dialog-content>
        <div class="fx-column" id="listWrapper">
            <mat-selection-list #areas [multiple]="true" (selectionChange)="onSetCheckbox($event)">
                <ng-container *ngFor="let a of areas$">
                    <mat-list-option value="{{a.prdAreaID}}" checkboxPosition="before" [selected]="a.checked" data-test="CheckboxListWrapper__option">
                        <span [innerHTML]="a.prdAreaNameEn"></span>
                    </mat-list-option>
                </ng-container>
            </mat-selection-list>
        </div>
    </mat-dialog-content>
    <br /> 
    <mat-dialog-actions class="fx-align-center">
        <button mat-button mat-raised-button mat-dialog-close (click)="cancel()">{{ "cancel" | translate }}</button>
        <button mat-button mat-raised-button color="accent" data-test="CheckboxListWrapper__areas" (click)="onOpenAreas()">{{ "addArea" | translate }}</button>
        <button mat-button mat-raised-button color="primary" [mat-dialog-close] data-test="CheckboxListWrapper__add">{{ "save" | translate }}</button>
    </mat-dialog-actions>
</ng-container>

